module.exports = __webpack_public_path__ + "img/soft_1.c84515f1.png";